<template>
    <!--:ok-disabled="exportStarted" ok-title="Export" @ok="exportFile" @cancel="closeModal"  cancel-title="Close" cancel-variant="btn-link"-->
    <b-modal v-model="showExportModal" id="export-wrapper" size="lg" body-class="px-0" :title="exportWinTitle" title-class="h1" hide-footer="true" header-close-content="X" header-close-label="X">
            <div class="model-body-container px-3">
                <h2 v-show="!downloadStarted">Select options for export:</h2>
                <div class="export-fields" id="export-items" v-show="!downloadStarted">
                    <div v-if="loadExportFields && ($route.name === 'list' || exportSectionName === 'subProjects' || exportSectionName === 'projectHistory')" class="loading"><span class="loader">Loading...</span></div>
                    <div class="export-error" v-if="exportError !== ''">{{exportError}}</div>
                    <div class="row">
                        <div class="col-md-4 section-header">Format:</div>
                        <div class="col-md-8">
                            <div class="form-check form-check-inline">
                                <input name="export-format" id="export-format-csv" type="radio"
                                    class="form-check-input"
                                    value="csv"
                                    v-model="exportFileFormat" />
                                <label for="export-format-csv" class="form-check-label">	CSV</label>
                            </div>
                            <div class="form-check form-check-inline" :class="{'disabled': fromPage === 'patents'}">
                                <input name="export-format" id="export-format-excel" type="radio"
                                    class="form-check-input"
                                    v-model="exportFileFormat"
                                    :disabled="fromPage === 'patents'"
                                    value="xlsx"/>
                                <label for="export-format-excel" class="form-check-label">	Excel</label>
                            </div>
                            <div class="form-check form-check-inline" v-if="fromPage === 'publications1'">
                                <input name="export-format" id="export-format-medline" type="radio"
                                    class="form-check-input"
                                    v-model="exportFileFormat"
                                    value="medline"/>
                                <label for="export-format-medline" class="form-check-label">	Medline</label>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-if="fromPage === 'searchResults' || fromPage === 'matchmakerResults' || exportSectionName === 'subProjects' || exportSectionName === 'projectHistory'">
                        <div class="col-md-4 section-header">Columns:</div>
                        <div class="col export-field-container">
                            
                            <div class="form-check form-check-inline" v-if="exportFields">
                                <input name="export-select-all" id="export-select-all" type="checkbox"
                                    class="form-check-input"
                                    value="false"
                                    :checked="selectedFieldsToExport.length === fieldCount"
                                    @click="checkAll()"
                                    :indeterminate.prop="selectedFieldsToExport.length > 0 && selectedFieldsToExport.length < fieldCount"
                                    />
                                <label for="export-select-all" class="form-check-label section-header">Select All</label>
                            </div>
                            <ul v-if="exportFields">
                                <template v-for="(parentField, facetIndex) in exportFields">
                                    <li :key="facetIndex" class="form-check" v-if="parentField && parentField.children_values && parentField.children_values.length > 0">
                                        <input :name="'parent-field-' + facetIndex" :id="'parent-field-' + facetIndex" type="checkbox"
                                            class="form-check-input"
                                            :value="parentField.value"
                                            :indeterminate.prop="isIndeterminate(parentField)"
                                            :checked="isChecked(parentField)"
                                                @click="checkCheck(parentField)" />
                                        <label :for="'parent-field-' + facetIndex" class="form-check-label section-header">
                                            {{parentField.display}}
                                            <b-link
                                                v-b-toggle="'exportCollapse-' + index + '-' + facetIndex"
                                                variant="link"
                                                rel="noopener"
                                                class="collapse-button collapse-facet"
                                                :aria-expanded="facetIndex == 0 ? true : false"
                                                :aria-controls="'#exportCollapse-' + index + '-' + facetIndex"
                                            >
                                                <i class="fas fa-angle-right collapse-icon"></i>
                                                <span class="sr-only">></span>
                                            </b-link>
                                        </label>


                                        <b-collapse :id="'exportCollapse-' + index + '-' + facetIndex" :visible="facetIndex === 0 && index === 0">
                                            <ul>
                                                <template v-for="(field, key1) in exportFields">
                                                <li v-if="parentField.children_values.indexOf(field.value) != -1"  :key="'key-' + facetIndex + '-' + key1" >
                                                    <div class="form-check form-check-inline">
                                                        <input :name="'field-' + field.value" :id="'field-' + field.value" type="checkbox" class="form-check-input"
                                                        v-model="selectedFieldsToExport" :value="field.value">
                                                        <!-- :value="field.value" -->
                                                        <label :for="'field-' + field.value" class="form-check-label">
                                                            <span class="label-text">{{field.display}}</span>
                                                        </label>
                                                    </div>
                                                </li>
                                                </template>
                                            </ul>
                                        </b-collapse>
                                    </li>
                                </template>
                            </ul>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 section-header">{{sectionHeader}} To Download:</div>
                        <div class="col-md-8">
                            15000 (max records)
                        </div>
                    </div>
                    <div class="row" v-if="fromPage === 'searchResults'">
                        <div class="col-md-4 section-header">Export Search Criteria:</div>
                        <div class="col-md-8">
                            <div class="form-check form-check-inline">
                                <input name="export-format" id="export-criteria" type="checkbox" class="form-check-input" v-model="exportSearchCriteria">
                                <label for="export-criteria" class="form-check-label visually-hidden"><span  class="label-text">export search criteria</span></label>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="exportLoader" v-if="downloadStarted">
                    <div class="export-message">
                        <span :class="exportFileMsgCls">{{exportFileMsg}}</span>
                    </div>
                    <div id="progressContainer">
                        <div id="progressBar"></div>
                    </div>
                </div>
            </div>
            <div class="text-end p-3 border-top">
                <b-button name = "close-btn" variant="link"  @click="closeModal()">Close</b-button>
                <button name = "export-btn" type="button" class="btn btn-primary export-btn" @click.prevent="exportFile()" v-if="!downloadStarted">Export</button>
            </div>
    </b-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import bus from '@/shared/event-bus.js';
import { defineExpose, ref } from 'vue'

const exportModule = ref(null)

defineExpose({ exportModule })
export default {
    name: 'exportModule',
    data: function () {
        return {
            currentPath: null,
            index: 0,
            selectedFieldsToExport: [],
            downloadStarted: false,
            exportError: '',
            exportFileMsg: 'Please wait while the export file is prepared',
            exportFileMsgCls: '',
            exportProgress: 0,
            exportId: null,
            exportTimer: 500,
            exportSpeed: 1,
            loadExportFields: false,
            exportSearchCriteria: true,
            exportFileFormat:'csv',
            progressTimer: null,
            statusTimer: null,
            fileDownloaded: false,
            exportWinTitle: 'Export ' + (this.exportModuleName ? this.exportModuleName : ''),
            showExportModal: false,
            exportStarted: false
        }
    },
     computed: {
        ...mapGetters([
            'exportFields',
            'isExportingFile',
            'defaultFieldsToExport',
        ]),
        fieldCount: function () {
            var cnt = 0;

            if (this.exportFields) {
                let childNode = this.exportFields.filter((item) => {
                    return !item.children_values;
                });

                cnt += childNode.length;
            }

            return cnt;
        },
        sectionHeader: function () {
            switch (this.$route.name) {
                case 'publications':
                case 'publication-search-results':
                    return 'Publications';
                case 'patents':
                    return 'Patents';
                case 'clinicalStudies':
                    return 'Clinical Studies';
                default:
                    return 'Projects';
            }
        }
    },
    props: {
        fromPage: {
            required: false
        },
        exportSectionName: {
            required: false
        },
        exportModuleName: {
            required: false
        }
    },
    watch: {
        exportFields: function (val) {
            if (val.length > 0) {
                this.selectedFieldsToExport = [];
                for (let i = 0; i < val.length; i++) {
                    if (val[i].properties.IsDefault && !val[i].children_values && val[i].value) {
                        this.selectedFieldsToExport.push(val[i].value);
                    }
                }
            }
            this.setDefaultfieldsToExport(copyData(this.selectedFieldsToExport));
        }
    },
    mounted () {
       // const {show, hide, modal} = useModal('export-wrapper')
        bus.$off('export:init');
        bus.$on('export:init', () => {
            this.initExportModule();
            this.showExportModal = true;
        });
    },
    methods: {
        ...mapActions([
            'setExportingFileFlag',
            'setCurrentExportTab',
            'setDefaultfieldsToExport'
        ]),
        initExportModule () {
            if (!this.isExportingFile) {
                var progressBar = document.getElementById("progressBar");

                if (!this.exportFields) {
                    this.loadExportFields = true;
                    this.$parent.getExportFields();
                }
                this.width = 1;
                this.exportError = '';
                this.exportId = null;
                this.downloadStarted = false;
                this.selectedFieldsToExport = copyData(this.defaultFieldsToExport);
                this.exportFileMsgCls = '';
                this.exportFileMsg = 'Please wait while the export file is prepared';
                if (progressBar) {
                    progressBar.classList.remove('error');
                    progressBar.classList.remove('complete');
                    progressBar.style.width = '1%';
                }
                if (this.$route.name === 'clinicalStudies') {
                    this.startExport();
                }
            } else {
                this.downloadStarted = true;
            }
        },
        closeModal () {
            this.showExportModal = false;
        },
        isChecked (field) {
            let secondLevel = field.children_values,
                checkedTotal = 0;

            for (let i = 0; i < secondLevel.length; i++) {
                if (this.selectedFieldsToExport.indexOf(secondLevel[i]) !== -1) {
                    checkedTotal++;
                }
            }

            if (checkedTotal > 0 && checkedTotal === secondLevel.length) {
                return true;
            } else if (checkedTotal === 0) {
                return false;
            }
        },
        isIndeterminate (field) {
            let secondLevel = field.children_values,
                checkedTotal = 0;

            for (let i = 0; i < secondLevel.length; i++) {
                if (this.selectedFieldsToExport.indexOf(secondLevel[i]) !== -1) {
                    checkedTotal++;
                }
            }

            if (checkedTotal > 0 && checkedTotal !== secondLevel.length) {
                return true;
            }

            return false;
        },
        checkCheck (field) {
            let secondLevel = field.children_values,
                checkedTotal = 0,
                self = this,
                curState = event.target.checked;

            this.exportError = '';
            setTimeout(() => {
               for (let i = 0; i < secondLevel.length; i++) {
                    if (self.selectedFieldsToExport.indexOf(secondLevel[i]) !== -1) {
                        if (!curState) {
                            self.selectedFieldsToExport.splice(self.selectedFieldsToExport.indexOf(secondLevel[i]), 1);
                        }
                    } else {
                        self.selectedFieldsToExport.push(secondLevel[i]);
                    }
                }
            }, 1);
        },
        checkAll () {
            var curState = event.target.checked,
                tempExportFields = this.exportFields
                self = this;

            self.selectedFieldsToExport = [];
            if (curState) {
                setTimeout(() => {
                    for (let i = 0; i < tempExportFields.length; i++) {
                        if (tempExportFields[i].children_values) {
                            self.selectedFieldsToExport = self.selectedFieldsToExport.concat(tempExportFields[i].children_values);
                        }
                    }
                }, 1);
            }
        },
        exportFile () {
            this.exportProgress = 1;
            if (this.selectedFieldsToExport && this.selectedFieldsToExport.length > 0) {
                this.exportStarted = true;
                this.startExport();
            } else {
                this.exportError = 'Please select field(s) to export';
            }
        },
        startExport () {
            var self = this;

            self.exportProgress = 1;
            self.fileDownloaded = false;
            self.downloadStarted = true;
            self.setExportingFileFlag(true);
            self.setCurrentExportTab(self.$route.name);
            self.$parent.exportData(self.selectedFieldsToExport, self.checkExportStatus);
            self.progressTimer = setTimeout(function () {
                self.trackProgress();
            }, self.exportTimer);
        },
        trackProgress () {
            if (this.exportId) {
                clearTimeout(this.progressTimer);
                this.$parent.getExportStatus(this.exportId, this.checkExportStatus);
            } else {
                this.checkExportStatus({
                    records_written: 0,
                    total_records: 100,
                    end_time: null,
                    id: null
                });
            }
        },
        checkExportStatus (data) {
            var exportStatus = data,
                progressBar = document.getElementById("progressBar"),
                self = this;

                clearTimeout(self.statusTimer);
                self.exportId = exportStatus.id;
                self.exportSpeed = -((self.exportProgress / 100) - 1);

                // exportProgress
                if (exportStatus.records_written === 0) {
                    if (this.exportProgress < 50) {
                        this.exportProgress += this.exportSpeed;
                    } else if (this.exportProgress < 75) {
                        this.exportProgress += this.exportSpeed * 0.25;
                    }
                } else if (this.exportPercent > this.exportProgress) {
                    this.exportProgress = this.exportPercent;
                }

                if (progressBar) {
                    progressBar.style.width = this.exportProgress + '%';
                }

                if (!exportStatus.end_time) {
                    self.statusTimer = setTimeout(function () {
                        self.trackProgress();
                    }, this.exportTimer);
                } else {
                    if (!this.fileDownloaded) {
                        this.fileDownloaded = true;
                        this.setExportingFileFlag(false);
                        this.exportStarted = false;
                        if (exportStatus.has_timed_out) {
                            if (progressBar) {
                                progressBar.classList.add('error');
                            }
                            this.exportFileMsg = 'The file export is taking longer than expected. Please try again later.';
                            this.exportFileMsgCls = 'error';
                        } else if (exportStatus.has_errors) {
                            if (progressBar) {
                                progressBar.classList.add('error');
                            }
                            this.exportFileMsg = 'An error has occurred generating the download file. Please try again.';
                            this.exportFileMsgCls = 'error';
                        } else {
                            if (progressBar) {
                                progressBar.classList.add('complete');
                            }
                            this.exportFileMsg = 'File complete!';
                            this.exportFileMsgCls = '';

                            setTimeout(function () {
                                var downloadButton = document.createElement('a');

                                    downloadButton.setAttribute('href', "/services/Download?filename=" + exportStatus.file_name);
                                    downloadButton.setAttribute('download', exportStatus.file_name);
                                    downloadButton.setAttribute('id','export-download');
                                    downloadButton.setAttribute('style','opacity: 0;');

                                    document.body.appendChild(downloadButton);
                                    downloadButton.click();
                                    downloadButton.parentElement.removeChild(downloadButton);
                            }, 301);
                        }
                    }
                }
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@/scss/variables.scss';



    .modal-body {
        .model-body-container {
            height: 350px;
        }
        .export-fields {
            h2 {
                margin: 8px 0 0 10px;
                color: #6b6b6b;
            }
            ul {
                list-style: none;
                li {
                    margin: 10px 0;
                    ul {
                        li {
                            margin: 3px 0;
                        }
                    }
                }
            }
            .collapse-icon {
                width: 15px;
                height: 15px;
                fill: #99aed8;
                -webkit-transition: 0.3s;
                transition: 0.3s;
                margin-left: 10px;
            }
            .collapse-button[aria-expanded="true"] {
                .collapse-icon {
                        transform: rotate(90deg);
                }
            }
            .form-check-label {
                color: #6b6b6b;
                font-size: 13px;
                &.section-header {
                    font-size: 15px;
                    font-weight: bold;
                    color:$blue-nih;
                }
            }
            .export-field-container {
                overflow-y: auto;
                overflow-x: hidden;
                height: 210px;
                margin-right: 1px !important;
            }
            .section-header {
                font-size: 15px;
                font-weight: bold;
                color:$blue-nih;
            }
        }


        .export-error {
            display: block;
            width: 100%;
            // padding: 0.25em 0;
            margin-top: 5px;
            color: #cc4545;
            font-weight: 500;
            // background-color: rgb(240, 214, 214);
            border-radius: 4px;
            margin-left: 10px;
        }
        .custom-control-inline {
            &.disabled {
                opacity: 0.7;
                .form-check-input {
                    cursor: not-allowed;
                }
                .form-check-label {
                    cursor: not-allowed;
                }
            }
        }
    }

    #progressContainer {
        width: 100%;
        height: 20px;
        background-color: $grey-lighter;
        border-radius: 3px;
        overflow: hidden;
        &.hide {
            display: none;
        }
    }
    #progressBar {
        width: 0;
        height: 100%;
        background-color: $blue;
        // border-radius: 3px;
        box-shadow: 0 0 10px #fff;
        &.complete {
            transition: 0.3s;
            background-color: #35A448;
            width: 100% !important;
        }
        &.error {
            transition: 0.3s;
            background-color: $red;
            width: 50% !important;
        }
    }

    .export-message {
        margin-bottom: 20px;
        text-align: center;
        width: 100%;
        color: $grey;
        font-size: 15px;
        .error {
            color: $red;
        }
    }

</style>
